module.exports = __webpack_public_path__ + "img/_prcent@2x.db89ef01.png";